export enum NavigationElement {
  MEDIABANK = 'mediabank',
  NEWS = 'news',
  PRESS_RELEASES = 'press-releases',
}
